import { z } from 'zod';

export const webPageComponentSchema = z.object({
  type: z.object({
    resolvedName: z.string(),
  }),
  isCanvas: z.boolean(),
  props: z.record(z.string(), z.unknown()),
  displayName: z.string(),
  custom: z.object({
    debugMode: z.boolean(),
    displayName: z.string(),
  }),
  parent: z.string(),
  hidden: z.boolean(),
  nodes: z.array(z.string()),
  linkedNodes: z.record(z.string(), z.unknown()),
});

export type WebPageComponentType = z.infer<typeof webPageComponentSchema>;